import { render, staticRenderFns } from "./MetaDeck.vue?vue&type=template&id=6d6589d4&scoped=true&"
import script from "./MetaDeck.vue?vue&type=script&lang=ts&"
export * from "./MetaDeck.vue?vue&type=script&lang=ts&"
import style0 from "./MetaDeck.vue?vue&type=style&index=0&id=6d6589d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6589d4",
  null
  
)

export default component.exports